import { createSlice } from '@reduxjs/toolkit';
var initialState = {
    data: []
};
export var LogsReducer = createSlice({
    name: 'logs',
    initialState: initialState,
    reducers: {
        setLogs: function setLogs(state, action) {
            state.data = action.payload;
        },
        deleteLog: function deleteLog(state, action) {
            state.data = state.data.filter(function (item) {
                return item.fileName !== action.payload;
            });
        }
    }
});
var _LogsReducer$actions = LogsReducer.actions, setLogs = _LogsReducer$actions.setLogs, deleteLog = _LogsReducer$actions.deleteLog;
export { setLogs, deleteLog };
export default LogsReducer.reducer;
